import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import {CacheUtilService} from "./services/cache-util/CacheUtilService";

import {AuthGuard} from "./services/auth/AuthGuard";
import {AlertService} from "./services/alert/alert.service";
import {BaseHttpService} from "./services/base-http-service";
import {HttpHandlerService} from "./services/httpHandler.service";
//import {CacheService} from "../../node_modules/ng2-cache/src/services/cache.service";
import {AuthService} from "./services/auth/AuthService";
import {FormBuilder} from '@angular/forms';
import {CompanyService} from "./services/company-service/company-service";
import {CategoryService} from "./services/category/category.service";
import {ServantService} from "./services/servant-service/servant-service";
import {SharingService} from "./services/sharing/sharing.service";


@Injectable()
export class DataResolver implements Resolve<any> {
  public resolve(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    return Observable.of({res: 'I am data'});
  }
}

/**
 * An array of services to resolve routes with data.
 */
export const APP_RESOLVER_PROVIDERS = [
  DataResolver,
  //CacheService,

  CacheUtilService,
  AuthService,
  AuthGuard,
  AlertService,
  BaseHttpService,
  HttpHandlerService,
  FormBuilder,
  CompanyService,
  CategoryService,
  SharingService,
  ServantService

];



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.resolver.ts